import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const CategoricalDonut = ({ title, values = [], subtitles = [], colors = [], height = 350, totalLabel = 'Total' }) => {
    const options = {
        chart: {
            type: 'donut',
            toolbar: {
                show: true
            }
        },
        labels: subtitles,
        colors,
        legend: {
            show: true,
            position: 'bottom',
            labels: {
                colors: '#000',
                useSeriesColors: false
            },
            itemMargin: {
                horizontal: 10,
                vertical: 5
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ['#fff'],
                fontSize: '12px'
            },
            formatter: (val) => `${val ? Number(val).toFixed(2) : '0.00'}%`
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: true,
                        value: {
                            fontSize: '22px',
                            fontWeight: 600,
                            formatter: (val) => Number(val).toLocaleString('pt-BR')
                        },
                        total: {
                            show: true,
                            label: totalLabel,
                            fontSize: '13px',
                            formatter: (w) =>
                                w.globals.seriesTotals
                                    .reduce((acc, curr) => acc + curr, 0)
                                    .toLocaleString('pt-BR')
                        }
                    }
                }
            }
        },
        tooltip: {
            y: {
                formatter: (val) => (val || val === 0 ? val.toLocaleString('pt-BR') : '')
            }
        }
    };

    return (
        <ChartContainer
            title={title}
            options={options}
            series={values}
            type="donut"
            height={height}
            className="categorical-donut-container"
        />
    );
};
